// extracted by mini-css-extract-plugin
module.exports = {"appcard":"PendingAppCard_appcard__kYMaU","headingcontainer":"PendingAppCard_headingcontainer__21ZNJ","statuscontainer":"PendingAppCard_statuscontainer__32DUC"};